import { render } from "./Person.vue?vue&type=template&id=d02939ec"
import script from "./Person.vue?vue&type=script&lang=js"
export * from "./Person.vue?vue&type=script&lang=js"
script.render = render

export default script